import { render } from "./IconVectorDark.vue?vue&type=template&id=19d93be0"
import script from "./IconVectorDark.vue?vue&type=script&lang=js"
export * from "./IconVectorDark.vue?vue&type=script&lang=js"

import exportComponent from "/home/node/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__